// eslint-disable-next-line
<template>
  <div>
<!--    <v-toolbar flat color="white">-->
<!--      <v-toolbar-title v-for="header in $store.state.payments.hbGroup"-->
<!--                       :key="header.id">{{-->
<!--          $store.state.payments.transactionTypes.find(m => m.value === header.id).text-->
<!--        }}-->
<!--        ({{ header.value | formatMoney }})-->
<!--      </v-toolbar-title>-->
<!--    </v-toolbar>-->

    <v-data-table
        :headers="headersGroup"
        :items="this.$store.state.payments.hbGroup"
        :pagination.sync="pagination"

        hide-actions
    >
      <template v-slot:headers="props">
        <tr>
          <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                    'column sortable',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
              @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-center">
            {{  $store.state.payments.transactionTypes.find(m => m.value ===  props.item.id).text  }}
          </td>
          <td class="text-xs-center">{{ props.item.count }}</td>
          <td class="text-xs-center">
            {{ props.item.total | formatMoney }}
          </td>
          <td class="text-xs-center">
            {{ props.item.calculatePrice | formatMoney }}
          </td>

          
        </tr>
      </template>
    </v-data-table>
    
    <v-toolbar flat color="white">
      <v-toolbar-title>Ödemeler</v-toolbar-title>
    </v-toolbar>
    
    <!-- Responsive Filter Container -->
    <v-container fluid class="pa-2">
      <v-layout wrap>
        <!-- Date and Search Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="startDate"
                      label="Baş. Tarihi"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    @change="initialize"
                    v-model="startDate"
                    locale="tr-TR"
                    @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                      v-model="endDate"
                      label="Bit. Tarihi"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                    @change="initialize"
                    v-model="endDate"
                    locale="tr-TR"
                    @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            
            <v-flex xs12 sm6 md3 class="px-1">
              <v-text-field
                  v-model="search"
                  @keyup.enter.native="initialize"
                  append-icon="search"
                  label="Ara"
                  clearable
              ></v-text-field>
            </v-flex>
            
            <v-flex xs12 sm6 md3 class="px-1">
              <v-btn color="primary" block @click="initialize" class="mt-3">
                <v-icon left>search</v-icon>
                Ara
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        
        <!-- Filter Fields Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md6 class="px-1">
              <v-combobox
                  v-model="select"
                  :items="$store.state.payments.transactionTypes"
                  item-value="value"
                  @change="initialize"
                  item-text="text"
                  label="Sipariş Durumları"
                  clearable
              ></v-combobox>
            </v-flex>
            
            <v-flex xs12 sm6 md6 class="px-1">
              <v-combobox
                  v-model="selectTransactionStatus"
                  :items="$store.state.payments.transactionStatus"
                  item-value="value"
                  @change="initialize"
                  item-text="text"
                  label="Ödeme Durumları"
                  clearable
              ></v-combobox>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
        :headers="headers"
        :loading="this.$store.state.progress"
        :rows-per-page-items="pageItems"
        :items="payments"
        :pagination.sync="pagination"
        item-key="id"
        select-all
        v-model="selected"
        class="elevation-1"
    >
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
            ></v-checkbox>
          </th>
          <th
              v-for="header in props.headers"
              :key="header.text"
              class="px-0 text-xs-left"
              :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
              @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected" @click="props.selected = !props.selected">
          <td>
            <v-checkbox
                :input-value="props.selected"
                primary
                hide-details
            ></v-checkbox>
          </td>
          <td class="px-2">{{ props.item.orderDate | formatDate }}</td>
          <td class="px-2">{{ props.item.quantity }}</td>
          <td class="px-2">{{ props.item.orderNumber }}</td>
          <td class="px-2">{{ props.item.sku }}</td>
          <td class="px-2">Hb:{{ props.item.amount.value | formatMoney }} -
            Hesaplanan:{{ props.item.calculatePrice | formatMoney }}
          </td>
          <td class="px-2">
            <span v-if="props.item.calculateDiff!=0"
                  style="background-color: red; color:white;"> {{ props.item.calculateDiff | formatMoney }}</span>
            <span v-else> {{ props.item.calculateDiff | formatMoney }}</span>

          </td>
          <td class="px-2">
            {{ $store.state.payments.transactionTypes.find(m => m.value === props.item.transactionType).text }}
          </td>
          <td class="px-2"> {{ props.item.status === 0 ? "Ödeme Bekleniyor" : "Ödendi" }}</td>
        </tr>
      </template>

    </v-data-table>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md8>
        <v-divider class="mx-2" inset vertical></v-divider>
      </v-flex>
      <v-flex xs12 md2>
        <v-combobox
            v-model="selectedAction"
            :items="$store.state.payments.transactionStatus"
            item-value="value"
            @change="initialize"
            item-text="text"
            hide-details
        ></v-combobox>
      </v-flex>
      <v-flex xs12 md3>
        <download-excel
            class="v-btn warning"
            :data="excelData"
            :fields="json_fields"
            worksheet="Ödeme Fark"
            name="Farklar.xls"
        >Excele Aktar
        </download-excel
        >
      </v-flex>
      <v-flex xs12 md2>
        <v-btn color="primary" dark @click="saveAction" class="mb-2"
        >Güncelle
        </v-btn
        >
      </v-flex>

    </v-layout>
  </div>
</template>
<script>

import moment from "moment/moment";

export default {
  data: () => ({
    startDate: "2025-04-01",// new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    tenantId: 0,
    insuranceDialog: false,
    menu2: false,
    hasAverage: null,
    pagination: {
      sortBy: "name",
    },
    files: null,
    select: {value: -1, text: "Tümü"},
    selectTransactionStatus: {value: -1, text: "Tümü"},
    selectedAction: {value: -1, text: "Durum Seç"},
    search: null,
    selected: [],
    insuranceItems: [],
    payments: [],
    pageItems: [
      50,
      100,
      500,
      {text: "$vuetify.dataIterator.rowsPerPageAll", value: -1},
    ],
    max: 0,


    headersGroup: [
      {text: "Tip", value: "id"},
      {text: "Adet", value: "count"},
      {text: "Hb Total", value: "total"},
      {text: "Hesaplanan", value: "CalculatePrice"},
    ],
    headers: [
      {text: "Sipariş Tarih", value: "orderDate"},
      {text: "Adet", value: "quantity"},
      {text: "Sipariş No", value: "orderNumber"},
      {text: "Sku", value: "sku"},
      {text: "Satış Fiyatı", value: "amount.value"},
      {text: "Fark", value: "calculateDiff"},
      {text: "Tip", value: "transactionType"},
      {text: "Durum", value: "status"},
    ],
    json_fields: {
      Tarih: "orderDate",
      Adet: "quantity",
      "Sipariş No": "orderNumber",
      Sku: "sku",
      "Hb Satış Fiyatı": {
        field: "amount",
        callback: (value) => {
          return value.toString().replace(".", ",");
        },
      },
      "Hesaplanan Satış Fiyatı": {
        field: "calculatePrice",
        callback: (value) => {
          return value.toString().replace(".", ",");
        },
      },
      Fark: {
        field: "calculateDiff",
        callback: (value) => {
          return value.toString().replace(".", ",");
        },
      },
      Tip:"transactionType",
      Durum:"status",
    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
  },
  computed: {
    excelData() {

      return this.payments.map(row => ({
        orderDate: `${moment(String(row.orderDate)).format("DD.MM.YYYY HH:mm")}`,
        quantity: row.quantity,
        orderNumber: row.orderNumber,
        Sku: row.sku,
        amount: row.amount.value,
        calculatePrice: row.calculatePrice,
        calculateDiff: row.calculateDiff,
        transactionType: this.$store.state.payments.transactionTypes.find(m => m.value === row.transactionType).text,
        status: `${row.status === 0 ? "Ödeme Bekleniyor" : "Ödendi"}`
      }));
    }
  },
  methods: {
    async initialize() {
      this.$store.dispatch("payments/hbStatusGroup", {
        startDate: this.startDate,
        endDate: this.endDate,
        type: this.select.value,
        transactionStatus: this.selectTransactionStatus.value
      }).then(() => {
      });

      await this.$store.dispatch("payments/searchPayment", {
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
        type: this.select.value,
        transactionStatus: this.selectTransactionStatus.value
      });
      this.payments = this.$store.state.payments.all;
    },
    getDate(day) {
      return new Date()
          .addDays(day)
          .toISOString()
          .substr(0, 10);
    },
    editItem(item) {
      this.$router.push({name: "order-detail", params: {id: item.id}});
    },
    async saveAction() {
      await this.$store.dispatch("payments/bulkUpdateStates", {
        selectedItems: this.selected,
        stateId: this.selectedAction.value,
      });
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";
      await this.initialize();
    },
    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
      this.$store.dispatch("payments/deletePayment", item);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.payments.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
  },
  async mounted() {
    this.tenantId = localStorage.getItem("tenantId");
    if (this.tenantId == 1)
      this.headers = this.headers.filter((m) => m.value != "customizedText01");

    await this.initialize();
  }
};
</script>
<style>
.redd {
  color: red;
}
</style>
